/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BulkChallengeSendResult
 */
export interface BulkChallengeSendResult {
  /**
   *
   * @type {string}
   * @memberof BulkChallengeSendResult
   */
  shipmentId: string;
}

/**
 * Check if a given object implements the BulkChallengeSendResult interface.
 */
export function instanceOfBulkChallengeSendResult(
  value: object,
): value is BulkChallengeSendResult {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  return true;
}

export function BulkChallengeSendResultFromJSON(
  json: any,
): BulkChallengeSendResult {
  return BulkChallengeSendResultFromJSONTyped(json, false);
}

export function BulkChallengeSendResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BulkChallengeSendResult {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
  };
}

export function BulkChallengeSendResultToJSON(
  json: any,
): BulkChallengeSendResult {
  return BulkChallengeSendResultToJSONTyped(json, false);
}

export function BulkChallengeSendResultToJSONTyped(
  value?: BulkChallengeSendResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
  };
}
